import {Context, FC, useContext} from 'react'

type Props = {
  context: Context<any>
  modalToggle?: boolean
  modalTargetId?: string
}

const SelectList: FC<Props> = ({context, modalToggle, modalTargetId}) => {
  const {selected} = useContext(context)

  return (
    <>
      {selected.length > 0 && (
        <div className='d-flex justify-content-end align-items-center'>
          <div className='fw-bolder me-5'>
            <span className='me-2'>{selected.length}</span> Selected
          </div>

          <button
            type='button'
            className='btn btn-danger'
            {...(modalToggle && modalTargetId
              ? {
                  'data-bs-toggle': 'modal',
                  'data-bs-target': `#${modalTargetId}`,
                }
              : {})}
          >
            Delete Selected
          </button>
        </div>
      )}
    </>
  )
}

export default SelectList
